import React from 'react'
import styled from 'styled-components'

const offset = -85

const AnchorContainer = styled.div`
  display: block;
  position: relative;
  // This offset value accounts for the site's fixed header, which appears on top of section titles when an anchor link is used without offset. In the future it could be changed to have a different value on mobile, etc.
  top: ${offset}px;
  visibility: hidden;
`

type AnchorProps = {
  id?: string
  className?: string
  pathname?: string
}

export const Anchor: React.FC<AnchorProps> = ({ className, id, pathname }) => {
  return (
    <AnchorContainer className={className} id={id} data-pathname={pathname} data-type="anchor" />
  )
}
